import { useMutation } from '@tanstack/react-query';
import urls from '../../utils/urls';
import useNotify from '../useNotify';
import { getIntl } from '../../utils/intl';
import { appAPI } from '../../utils/api';
import { onResetProfileConnectionMetadata, refreshProfileDataRefreshProgress } from './cacheKeys';

const intl = getIntl('useOneUpRefreshSearch', {
    errorRefreshingData: 'Error refreshing data',
    refreshSuccess: 'Successfully began refreshing data',
});

export type UseOneUpRefreshArgs = {
    suppressSuccessNotification?: boolean;
};

export type useOneUpRefreshSearchReturnValue = {
    refresh: (profileId: string) => void;
    isRefreshing: boolean;
};

export default function useOneUpHealthRefresh({
    suppressSuccessNotification,
}: UseOneUpRefreshArgs = {}): useOneUpRefreshSearchReturnValue {
    const notify = useNotify();
    const refreshMutation = useMutation({
        mutationFn: async (medicalProfileId: string) => {
            await appAPI.post<void>(urls.api.ehrIntegrations.oneUpHealth.endpoints.refresh(medicalProfileId), {});
        },
        onSuccess: (_data, medicalProfileId) => {
            if (!suppressSuccessNotification) {
                onResetProfileConnectionMetadata.resetCache({ medicalProfileId })();
                notify('success', intl('refreshSuccess'));
            }

            setTimeout(() => {
                refreshProfileDataRefreshProgress.resetCache({ medicalProfileId })();
            }, 1000);
        },
        onError: () => {
            notify('error', intl('errorRefreshingData'));
        },
    });

    return {
        refresh: refreshMutation.mutate,
        isRefreshing: refreshMutation.isPending,
    };
}
